/* eslint-disable @typescript-eslint/camelcase */
import { handleFormSubmit, useAuth, useRequest } from '@polvo-labs/react-auth'
import React, { useEffect, useState } from 'react'
import { toast } from 'react-toastify'
import { confirm } from '../../../components/Dialog'
import Form from '../../../components/Form'
import FieldType from '../../../components/Form/Fields/type'
import Realty, { canUpdateRealty } from '../../../models/Realty'
import fields, { RealtyFormData } from '../fields'
import Axios from 'axios'
import routes from '../../../config/routes'
import { useHistory } from 'react-router-dom'

interface Props {
  initialValues: RealtyFormData & { id: string }
  onSubmit: () => void
}


const RealtyEditForm: React.FC<Props> = ({ initialValues, onSubmit }) => {
  const { request } = useRequest()
  const [fieldsIn,setFieldsIn] = useState<FieldType<keyof RealtyFormData>[]>(fields)
  const { token, user, setUser } = useAuth()
  const history = useHistory()
  useEffect(() => {

    const formFieldsIn = fields
    fields.forEach((field, index) => {
      if (field.name === 'adult') {
        const hide = user.accept_terms_conditions
          || user.accept_privacy_policy
        formFieldsIn[index].hide = hide
        delete formFieldsIn[index].validation
        // if(formFieldsIn[index].html !== undefined)
        //   formFieldsIn[index].html.checked = hide
      }
      if (field.name === 'accept_terms_conditions') {
        formFieldsIn[index].hide = user.accept_terms_conditions
      }
      if (field.name === 'accept_privacy_policy') {
        formFieldsIn[index].hide = user.accept_privacy_policy
      }
    })

    setTimeout(() => {
      setFieldsIn(formFieldsIn)
    }, 0)

  }, [user])


  function setIndexRealty() {
    history.push(routes.realty.index.path)
  }

  return (
    <Form<RealtyFormData>
      buttonLabel="ATUALIZAR"
      fields={fieldsIn}
      initialValues={initialValues}
      onSubmit={(data, form) => {
        if (canUpdateRealty((initialValues as Record<string, any>) as Realty)) {
          return handleFormSubmit({
            request: request({
              method: 'PUT',
              url: `${process.env.REACT_APP_API_URL}/realties/${initialValues.id}`,
              data,
            }),
            onValidationErrors: () => toast.error('Erros de validacao.'),
            onSuccess: (data) => {
              setUser?.({...user,
                accept_terms_conditions: user.accept_terms_conditions,
                accept_privacy_policy: user.accept_privacy_policy})
              if (data.status === 202) {
                confirm({
                  title: 'Informação',
                  message: data.data.data.message,
                  buttons: [
                    {
                      label: 'Sim',
                      onClick: () => {
                        data.birth_year = user.birth_year
                        data.contact_my_city = true
                        setIndexRealty()
                        Axios({
                          method: 'PUT',
                          url: `${process.env.REACT_APP_API_URL}/users/${user.id}`, data ,
                          headers: {
                            Authorization: `Bearer ${token}`,
                          },
                        }).then(({ data }) => {
                        })
                      },
                    },
                    {
                      label: 'Não',
                      onClick: () => {
                        setIndexRealty()
                      },
                    },
                  ],

                })
              } else {
                toast.success('Imóvel atualizado com sucesso.')
                setTimeout(() => {
                  form.reset()
                  onSubmit()
                })
              }
            },
            onFailure: (erro: any) => {
              toast.error('Erro ao alterar informações.')
              const errors = erro.toJSON()
              if (errors.errors) {
                return errors
              }
            },
          })
        } else {
          toast.error('Depois que o imóvel é aprovado, não pode ser modificado.')
        }
      }}
    />
  )
}

export default RealtyEditForm
